var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto",class:{
        'rounded-full': !!_vm.round,
        'shadow-xl': !_vm.flat && !_vm.border,
        'w-full ': !_vm.width,
        ['bg-'+_vm.color]: !!_vm.color,
        'text-white': _vm.dark,
        'p-4': !_vm.noPadding,
        ['border-'+_vm.borderColor]: !!_vm.border,
        ['overflow-'+_vm.overflow]: !!_vm.overflow,
        'h-full': !_vm.height

     },style:({
        width: !!_vm.width ? _vm.parse(_vm.width) : '100%',
        height: !!_vm.height ? _vm.parse(_vm.height) : '100%',
        'border-width': !!_vm.border ? _vm.parse(_vm.border) : '',
        'border-radius': !_vm.tile && !_vm.round ? '20px' : ''
     }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }